import * as React from 'react';

/**
 * Detect double press (mostly for web UX).
 */
export function useDoubleClick<Event>(
    onDoubleClick: (event: Event) => void,
    onSingleClick?: (event: Event) => void,
    delay = 500 // default double click speed on Windows
): (event: Event) => void {
    const clickTimeout = React.useRef<NodeJS.Timeout | null>(null);

    return (event: Event) => {
        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current);
            clickTimeout.current = null;
            onDoubleClick(event);
        } else {
            clickTimeout.current = setTimeout(() => {
                clickTimeout.current = null;
                onSingleClick?.(event);
            }, delay);
        }
    };
}
